import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

function RadioButtons({
  group, value, values, onChange, disabled, readOnly, vertical,
}) {
  return (
    <RadioGroup name={group} value={value} onChange={(e) => onChange(e, e.target.value)} row={!vertical}>
      {values.map((o) => (
        <FormControlLabel
          key={o.value}
          value={o.value}
          control={<Radio />}
          label={o.display_name || 'Без назви'}
          disabled={o.disabled || disabled || readOnly}
        />
      ))}
    </RadioGroup>
  );
}

export const valuePropType = PropTypes
  .oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

RadioButtons.propTypes = {
  value: valuePropType,
  values: PropTypes.arrayOf(PropTypes.shape({
    value: valuePropType,
    disabled: PropTypes.bool,
    display_name: PropTypes.string,
  })),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  group: PropTypes.string.isRequired,
  vertical: PropTypes.bool,
};

RadioButtons.defaultProps = {
  value: null,
  values: [],
  disabled: false,
  readOnly: false,
  vertical: false,
};

export default RadioButtons;
